module.exports = __webpack_public_path__ + "static/media/IconLixeira.df34d850.svg";